module.exports = __webpack_public_path__ + "static/img/arthroscopy-detail-01.bd663b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-detail-01.jpg
// module id = 0dL2
// module chunks = 51